import React from "react";
import MainLayout from "../../../../../../components/MainLayout/MainLayout";
import { Game } from "../../../../../../reactPages/game/Game";

const GamePage = () => {
  return (
    <>
      <MainLayout>
        <Game />
      </MainLayout>
    </>
  );
};

export default GamePage;
